<script>
    export let user_language;
    export let user_language_options;
</script>

<header>
    <div class="page-title">
        DORA Reflection
    </div>
    <div class="language-select">
        <select bind:value={user_language}>
            {#each Object.entries(user_language_options) as [lang_code, lang_name]}
                <option value={lang_code}>{lang_name}</option>
            {/each}
        </select>
    </div>
</header>

<style lang="scss">
    header {
        display:flex;
        flex-direction: row;
        padding: 1em;
        margin-bottom: 1em;
        background-color: var(--background-color-light);
        
        .page-title {
            text-align:left;
            flex-grow:1;
        }

        .language-select {
            text-align: right;
            flex-grow:1;
        }
    
    }
</style>
